import Styled from 'styled-components'

export const Category = Styled.h1`
`

export const Banner = Styled.div`
@media (min-width: 1024px) {
  margin-bottom: 24px;
  img {
    max-height: 280px;
    object-fit: cover;
    border-radius: 12px;
  }
}
`

export const CotainerProduct = Styled.div`
`

export const CheckboxContainer = Styled.div`
`

export const Checkbox = Styled.input`
`

export const Cashback = Styled.div`
`
export const Space = Styled.div`
`

export const FeaturedCategoriesBrands = Styled.div`
`

export const TitleProduct = Styled.p`
`
export const Label = Styled.p`
`

export const ContainerCarrousel = Styled.div`
`
export const Title = Styled.p`
`

/* Desktop: alinha o Container do Bootstrap ao padrão do header (1320/32) */
export const PageWrap = Styled.div`
  @media (min-width: 1024px) {
    .container {
      max-width: 1320px;
      padding-left: 32px;
      padding-right: 32px;
    }
  }
`;

/* Desktop: listagem em 2 colunas (filtros 280px + produtos) */
export const ListingLayout = Styled.div`
  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: 280px minmax(0, 1fr);
    gap: 32px;
    align-items: start;

    .product-grid {
      margin-left: 0;
      margin-right: 0;
    }
    .product-grid .col-6 {
      flex: 0 0 25%;
      max-width: 25%;
      width: 25%;
    }
  }
`;